import cx from 'classnames'
import styles from './ParaQuem.module.scss'
import { openWhatsApp } from '../constants'
import kidComputer from '../../assets/images/optimized/para-quem-criancas.webp'
import adultoSmartphone from '../../assets/images/optimized/para-quem-adultos.webp'

const CARDS = [
  {
    key: 'criancas',
    image: kidComputer,
    imageSize: { width: 1040, height: 780 },
    title: 'Para crianças e adolescentes',
    accent: 'navy' as const,
    items: [
      'Troca de sons',
      'Dificuldade de comunicação',
      'Gagueira',
      'Dificuldades escolares',
      'E muito mais',
    ],
  },
  {
    key: 'adultos',
    image: adultoSmartphone,
    imageSize: { width: 800, height: 468 },
    title: 'Para adultos',
    accent: 'gold' as const,
    items: [
      'Comunicação profissional',
      'Fala e articulação',
      'Fluência (gagueira)',
      'Voz',
      'E muito mais',
    ],
  },
]

const ParaQuem = () => (
  <section className={styles.section}>
    <div className={styles.inner}>
      <h2 className={styles.kicker}>Para quem é o atendimento</h2>
      <p className={styles.subtitle}>
        Atendimento fonoaudiológico online para crianças a partir dos 4 anos de
        idade, adolescentes e adultos.
      </p>

      <div className={styles.cards}>
        {CARDS.map(card => (
          <article key={card.key} className={styles.card}>
            <div className={styles.thumb}>
              <img
                src={card.image}
                alt={card.title}
                width={card.imageSize.width}
                height={card.imageSize.height}
                loading="lazy"
                decoding="async"
              />
            </div>
            <h3>{card.title}</h3>
            <ul>
              {card.items.map(item => (
                <li key={item}>
                  <i
                    className={cx('material-icons', {
                      [styles.navyCheck]: card.accent === 'navy',
                      [styles.goldCheck]: card.accent === 'gold',
                    })}
                  >
                    check
                  </i>
                  {item}
                </li>
              ))}
            </ul>
            <button
              type="button"
              className={cx(styles.cardBtn, {
                [styles.navyBtn]: card.accent === 'navy',
                [styles.goldBtn]: card.accent === 'gold',
              })}
              onClick={openWhatsApp}
            >
              Saiba mais
            </button>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ParaQuem
